<script setup>
import footers from '@/components/main/footer/footer.vue' // 页脚
import footerTow from '@/components/main/footer/footerTow.vue' // 页脚2

import contact from '@/components/main/sideEdge/contact.vue' // 侧边联系方式


import { parseHeziyunData } from '@/utils/heziyunData' // 解析数据



const HeziyunData = ref(parseHeziyunData() || {})

const normalizeList = value => {
    if (Array.isArray(value)) return value
    if (Array.isArray(value?.list)) return value.list
    return []
}

const lateral = computed(() => normalizeList(HeziyunData.value.lateral))

const friend = computed(() => normalizeList(HeziyunData.value.friend).map(item => ({
    ...item,
    title: item.title || item.titile || item.name || ''
})))

</script>

<template>
    <!-- 侧边 -->
    <contact :theme="HeziyunData.theme?.side" :lateral="lateral" v-if="HeziyunData.theme?.side == '1'"></contact>

    <!-- 页脚 -->
    <footers :common="HeziyunData.global" :friend="friend" v-if="HeziyunData.theme?.footer == '1'"></footers>
    <footerTow :common="HeziyunData.global" :friend="friend" v-if="HeziyunData.theme?.footer == '2'"></footerTow>
</template>
